import rg4js from 'raygun4js'
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import { PersistGate } from 'redux-persist/es/integration/react'
import registerServiceWorker from './registerServiceWorker';
import configureStore from './store/configureStore'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Main from './containers/Main';
import config from './config'

const {store, persistor} = configureStore()

rg4js('enableCrashReporting', true);
rg4js('apiKey', config.raygun_api_key)

// Test Exception
// throw TypeError("name must be a string")

// ReactDOM.render(
//
//     <MuiThemeProvider>
//       <Provider store={store}>
//         <PersistGate persistor={persistor} loading={<div />}>
//           <Router>
//             <Main store={store} />
//           </Router>
//         </PersistGate>
//       </Provider>
//     </MuiThemeProvider>
//     ,
//   document.getElementById('root')
// )

ReactDOM.render(

    <MuiThemeProvider>
      <Provider store={store}>
        <PersistGate persistor={persistor} loading={<div />}>
          <Router>
            <Main />
          </Router>
        </PersistGate>
      </Provider>
    </MuiThemeProvider>
    ,
  document.getElementById('root')
)

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js